import { render, staticRenderFns } from "./SimplePreloader.vue?vue&type=template&id=2f764570&scoped=true&"
import script from "./SimplePreloader.vue?vue&type=script&lang=js&"
export * from "./SimplePreloader.vue?vue&type=script&lang=js&"
import style0 from "./SimplePreloader.vue?vue&type=style&index=0&id=2f764570&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f764570",
  null
  
)

export default component.exports